import { ChangeDetectionStrategy, Component } from '@angular/core';
import { Router } from '@angular/router';
import { AuthenticationService } from '@common/services/authentication.service';
import { InstanceTrackerService } from '@common/services/instance-tracker.service';
import { currentUserSubject } from '@common/services/user.service';

@Component({
    template: '',
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class LogoutComponent {
    constructor(
        private authenticationService: AuthenticationService,
        private router: Router,
        private pingService: InstanceTrackerService
    ) {
        currentUserSubject.next(null);
        this.pingService.stopPing();
        localStorage.removeItem('ping');
        localStorage.setItem('loggedout', 'true');

        const pathOnly = (this.router.url || '').split('?')[0];
        // extract returnUrl from query params if present
        const parsed = this.router.parseUrl(this.router.url || '');
        const returnUrl = parsed.queryParams ? parsed.queryParams['returnUrl'] : null;

        if (pathOnly === '/logout/local') {
            this.authenticationService.logoutAndRedirectToLogin(null, true);
        } else {
            this.authenticationService.logoutAndRedirectToLogin(returnUrl);
        }
    }
}
